import { ReactElement } from 'react'
import { Breadcrumbs as MuiBreadcrumbs, Typography, styled } from '@mui/material'
import { Link } from 'react-router-dom'

const StyledLink = styled(Link)(() => ({
  textDecoration: 'none',
}))

const StyledBreadcrumbs = styled(MuiBreadcrumbs)(({ theme }) => ({
  margin: theme.spacing(2.5, 0),
  ol: {
    li: {
      color: theme.palette.grey[400],
      p: {
        color: theme.palette.grey[400],
      },
      '&:last-of-type': {
        p: {
          color: theme.palette.grey[50],
        },
      },
    },
  },
}))

export default function Breadcrumbs({ items }: { items: { path?: string; label: string }[] }): ReactElement {
  return (
    <StyledBreadcrumbs aria-label="breadcrumb">
      {items.map((it, ix) => {
        return !!it.path ? (
          <StyledLink to={it.path}>
            <Typography key={`breadcrumb-${ix}`}>{it.label}</Typography>
          </StyledLink>
        ) : (
          <Typography key={`breadcrumb-${ix}`}>{it.label}</Typography>
        )
      })}
    </StyledBreadcrumbs>
  )
}
